export const TABS = {
    GENERAL: {
        title: "General",
        eventKey: "general",
    },
    CUSTOMIZATION: {
        title: "Email Customization",
        eventKey: "customization",
    },
};

export const DEFAULT_ACTIVE_TAB_KEY = TABS.GENERAL.eventKey;
